import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash-es';
import { CircularProgress, InputAdornment, TextField } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useStoreActions, useStoreState } from 'store';
import type { FamilyContact } from 'types/domain';

import FourNotFour from '../containers/FourNotFour';
import ContactCard from '../components/ContactCard';

import { SearchIcon } from '../assets/icons';
import styles from './Contacts.module.css';

const theme = createTheme({
  palette: {
    primary: {
      main: "#1A3263",
    },
  },
});

const Contacts = () => {
  const { contacts, loading, fetched, error } = useStoreState(state => state.contacts);
  const { getContacts } = useStoreActions(actions => actions.contacts);
  const [visibleList, setVisibleList] = useState<FamilyContact[]>([]);

  useEffect(() => {
    if (isEmpty(contacts) && !fetched) {
      getContacts();
    }
    if (isEmpty(visibleList) && !isEmpty(contacts)) {
      setVisibleList(contacts);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contacts, fetched, getContacts]);

  const handleSearchInput = (ev: React.ChangeEvent<HTMLInputElement>) => {
    if (!isEmpty(ev.target.value)) {
      const searchInput = ev.target.value.toLocaleLowerCase();
      const newvisibleList = contacts.filter((contact) => {
        const familyHead = contact.familyHeadName?.toLocaleLowerCase() || '';
        const gotra = contact.gotraDetail?.toLocaleLowerCase() || '';
        const memberMatch = contact.familyDetails?.some((member) => {
          const name = member.name?.toLocaleLowerCase() || '';
          return name.includes(searchInput);
        });

        return familyHead.includes(searchInput) || gotra.includes(searchInput) || memberMatch;
      });
      setVisibleList(newvisibleList);
    } else {
      setVisibleList(contacts);
    }
  };

  if (loading) {
    return (
      <div className={styles.loaderWrapper}>
        <div>Fetching Contacts...</div>
        <CircularProgress className={styles.progress} />
      </div>
    )
  }

  if (error) {
    return (<FourNotFour />)
  }

  return (
    <div className={styles.container}>
      <ThemeProvider theme={theme}>
        <TextField
          className={styles.searchWrapper}
          id="memberSearch"
          label="Search Member"
          type="search"
          onChange={handleSearchInput}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="#1A3263" width={20} height={20} />
              </InputAdornment>
            ),
          }}
        />
      </ThemeProvider>
      {!isEmpty(visibleList) ? (
        visibleList.map((contact) => (
          <ContactCard key={contact.id} contact={contact} />
        ))
      ) : (
        <div className={styles.notFoundText}>No member found with this name.</div>
      )}
    </div>
  );
};

export default Contacts;